<template #default="{ errorMessages }">
  <div elevation="0" ref="formContainer">
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab && tab == 2"
        color="primary"
        dark
        fixed
        bottom
        right
        fab
        class="fab-questionary"
        @click="addQuestion()"
      >
        <v-icon class="buttonTextDefault--text">mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-tabs
      v-model="tab"
      centered
      grow
      active-class="font-weight-bold tab-active"
      slider-size="3"
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#1"  :class="`tab-header  ${stClasses.st1}`" >
        1 - Datos Generales
      </v-tab>

      <v-tab href="#2" :class="`tab-header  ${stClasses.st2}`">
        2 - Preguntas
      </v-tab>

    </v-tabs>

    <!-- STEP 1 "Datos generales" -->
    <v-tabs-items v-model="tab">
      <v-tab-item
        value="1"
      >
        <div class="mt-3">
          <v-row>
            <v-col>
              <textFieldForm
                name="p1"
                label="Nombre de la encuesta"
                :valueInput="values.name"
                :rule="rules.name"
                @valueChange="(v) => {values.name = v.trim(); delete serverErrors['name'];}"
                :errorMessages="serverErrors['name']"
                ></textFieldForm>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-2">
                <textAreaForm 
                    @valueChange="(v) => {values.instructions = v.trim(); delete serverErrors['instructions']}" 
                    :valueInput="values.instructions" 
                    :rule="[]" 
                    label="Instrucciones de llenado"
                    :errorMessages="serverErrors['instructions']"
                    :rows="1"
                ></textAreaForm>
            </v-col>
        </v-row>

        <v-row justify="center" class="text-center" v-if="loadingCompanies">
          <v-col>
            <v-progress-circular
              indeterminate
              color="primary"
              size="50"
            ></v-progress-circular>
          </v-col>
        </v-row>
       
        <v-row justify="space-between" v-if="!loadingCompanies">
            <v-col align-self="center" class="mb-0 pb-0">
              <p class="mb-0 font-weight-bold body-1">Empresas a aplicar</p>
                <p class="mb-0 font-weight-bold body-1">
                    Notificar a Todas las empresas
                </p>
            </v-col>
            <v-col
                class="text-right justify-end  mb-0 pb-0 just-items-end mr-0 pr-6"
                align-self="center"
            >
                <v-checkbox v-model="allSelected"></v-checkbox>
            </v-col>
        </v-row>

        

        <v-row v-if="!loadingCompanies">
            <v-col class="px-4">
                <v-card v-for="(item, i) in values.businessData" :key="i" class="questionnaires-business-list mb-2">
                    <template>
                        <v-expansion-panels  flat>
                            <v-expansion-panel>
                                <v-expansion-panel-header
                                class="pl-3 pr-3"
                                    @click="loadEmployees(item)"
                                >
                                    {{ item.businessName }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <table-items
                                        :props="companyTable"
                                        @methodHandler="method_handler"
                                        :items="item.employees"
                                        :valueInput="item.employees_notified"
                                        @valueChange="
                                            (v) => {
                                                item.employees_notified = v; inspectCheck(item);
                                            }
                                        "
                                    >
                                    </table-items>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </template>
                    <v-checkbox v-model="item.selectedBusiness" class="px-2" :ripple="false" @click="allEmployeesCheck(item)" ></v-checkbox>
                </v-card>
            </v-col>
        </v-row>


        </div>


      </v-tab-item>

      <!--STEP 2  "Documentación" --> 
      <v-tab-item
        value="2"
      >
        <div class="my-3 mx-1">
          <v-row>
            <v-col>
              <primaryButton
                :props="addQBtnData"
              ></primaryButton>
            </v-col>
          </v-row>


          <!--  -->

        
          <v-expand-transition v-for="(item, index) in values.questions" :key="index" appear>
          
           
           
            <questionItem
              name="p2"
              :index="index"
              :valuesInput="item"
              :rules="rules"
              :questionsList="questionsIndex"
              :serverErrors="serverErrors"
              @delete="(v) => {deleteQuestion(v)}"
              @addTo="(v) => {addToItem(v)}"
              @removeTo="(i,v) => {removeToItem(i,v)}"
              @addOption="(v) => {addMultiOption(v);}"
              @processMultiNotApply="(v) => {processMultiNotApply(v)}"
              @processMultiOther="(v) => {processMultiOther(v)}"
              @removeOption="(i,v) => {removeMultiOptionItem(i,v)}"
            ></questionItem>
           
            
          
         
          </v-expand-transition>
          <p class="my-0 py-0 error--text">{{serverErrors[`questions`]}}</p>
          


          <!--  -->

        </div>
      </v-tab-item>

    </v-tabs-items>



  </div>
</template>


<script>

/* eslint-disable */
export default {
    props: ['values', 'stepIn', 'stepClasses','serverErrors', 'edit'],
  
    model: {
      event: 'tabChanged'
    },
  
   
    computed: {
        tab: {
            get: function() {
                return this.stepIn
            },
            set: function(value) {
                console.log(value)
                this.$emit('tabChanged', value)
                //this.tab = stepIn;
            }
        },
        stClasses: {
            get: function() {
              return this.stepClasses
            },
            set: function(value) {
              console.log(value)
            //  this.$emit('tabChanged', value)
                //this.tab = stepIn;
            }
        }
    },
    data(){
        return {
          e1: 1,
          fab: false,
          //tab: '',
          show4: false,
          loadingCompanies: false,
          allSelected: false,
          questionsIndex:[],
          someEmployeeRemoved: 0,
          loadingEmployee: false,
          employeeSelected: "",
          
          rules: {
            name: [
                v => {
                    if(v == null || v == undefined)
                        return "Campo requerido";
                    try {
                        if(v.trim() == "")
                            return "Campo requerido";
                    } catch (error) {
                        console.log(error);
                    }
                    return true;
                }
            ],
            type: [
                v => !!v || 'El campo es requerido'
            ],
            apply_for:[
                v => {
                    if(v.length == 0)
                    return 'Al menos uno';
                    return true;
                }
            ],
            question: [
                v => !!v || 'El campo es requerido'
            ],


            action_response: [
                v => !!v || 'El campo es requerido'
            ],

            to: [
                v => !!v || 'El campo es requerido b'
            ],
          

          },


          serverItems: {
            companies: [],


            
          },

          companyTable: {
            headers: [
                {
                    text: "Colaboradores a notificar",
                    align: "left",
                    value: "name",
                    class: "table-b-border body-1 font-weight-bold",
                    sortable: false,
                },

                {
                    text: "",
                    align: "right",
                    sortable: false,
                    value: "data-table-select",
                    class: "table-b-border",
                },
            ],
            items: [],
            search: "",
            loading: false,
            showSelect: true,
            key: "id",
            showSelect: true,
        },


          addQBtnData: {
            text: "Agregar nueva pregunta",
            icon: "mdi-plus",
            to: "",
            block: true,
            click: ()=>{ this.addQuestion(); delete this.serverErrors[`questions`]}
          }

          
        }
    },
    watch: {
      allSelected: function (v) {
        console.log(v, this.values.businessData);
        
        this.values.businessData.forEach(b => {
            b.selectedBusiness = v;
            this.allEmployeesCheck(b);
        });
        this.values.employees = [];
      },
        
    },
    async mounted (){
      this.generateQuestionsIndexList();
      await this.getCompanies();
    },
    methods: {
      method_handler(object) {
        this[object.method_name](object.parameters);
      },
      inspectCheck(item){
        if(item.employees.length > item.employees_notified.length)
            item.selectedBusiness = false;
        if(item.employees.length == item.employees_notified.length)
            item.selectedBusiness = true;
        this.values.employees = this.values.employees.filter(x => x.businessId != item.businessId)
      },
      /**
       * load companies
       */
      getCompanies()
      {
        this.loadingCompanies = true;
        this.$api.user.getUserBusinessSelect()
				.then((resp) =>{
					console.log(resp, "desde form");
					this.values.businessData = resp.data.map((x) => {
            return {
                loading: false,
                businessId: x.id,
                businessName: x.name,
                employees: [],
                employees_notified: [],
                selectedBusiness: false,
            };
          });

          if(this.edit){
              this.setBusinessData();
          }
				})
				.catch((error) =>{
					console.log(error, "error desde form areas");
				})
				.finally(() => {
          this.loadingCompanies = false;
				})
			  ;
      },
      setBusinessData(){
        console.log("run set business")
        for (let i = 0; i < this.values?.apply_for?.length; i++) {
            let found = this.values.businessData.find((x) => x.businessId == this.values.apply_for[i].id)
            if(found != undefined){
                found.selectedBusiness = true;
            }
        }

        if(this.values.apply_for.length == this.values.businessData.length )
          this.allSelected = true;
      },
      allEmployeesCheck(item){
        console.log(item, "allEmployeesCheck")
        item.employees_notified = [];
        this.values.employees = this.values.employees.filter(x => x.businessId != item.businessId)
        if(item.selectedBusiness){
            item.employees_notified = item.employees.map((x) => {
                return x;
            });
        }
        console.log( this.values.employees, "allEmployeesCheck final final")
      },

      loadEmployees(item) {
        if (item.employees.length > 0) return;

        this.companyTable.loading = true;
        item.loading = true;
        this.$api.employees
            .emailsByBusiness(item.businessId)
            .then((resp) => {
              
                item.employees = resp.data.map((x) => {
                    return {
                        id: x.id,
                        name: x.name,
                        email: x.email,
                        businessId: item.businessId,
                        businessName: item.businessName
                    };
                });

                if(item.selectedBusiness){
                    item.employees_notified = resp.data.map((x) => {
                        return {
                            id: x.id,
                            name: x.name,
                            email: x.email,
                            businessId: item.businessId,
                            businessName: item.businessName
                        };
                    });
                }

                if(this.edit){
                    for (let i = 0; i < this.values.employees.length; i++) {
                        const found = item.employees_notified.find((x) => x.id == this.values.employees[i].id);
                        const found2 = item.employees.find((x) => x.id == this.values.employees[i].id);
                        if(found == undefined && found2 != undefined){
                            item.employees_notified.push(this.values.employees[i])
                        }
                        
                    }
                }

                //autocheck
                let fullList = true;
                item.employees.forEach(em => {
                    const found = item.employees_notified.find((x) => x.id == em.id);
                    if(found == undefined)
                        fullList = false;
                });

                item.selectedBusiness = fullList;
                
                console.log(item);
            })
            .catch((error) => {
                console.log(error, "error eventForm");
            })
            .finally(() => {
                item.loading = false;
                this.companyTable.loading = false;
            });
    },

      /**
       * Add question
       */
      addQuestion(){
       
        this.values.questions.push({
          id: + new Date(),
          type: "",
          required: false,
          question: "",
          instructions: "",

          //binary & multi use
          add_not_apply: "",

          //multi use
          add_other:"",
          option_list:[{option:""}],

          //binary use
          to_list: [],

          //scalar use
          start_tag: '',
          end_tag: '',

          //number use
          unit: ""
        });
        this.generateQuestionsIndexList();
        this.tobottom();
      },

      /**
       * Delete question
       */
      deleteQuestion(v){
        // console.log(this.values)
        this.values.questions.splice(v,1);
        this.generateQuestionsIndexList();
        this.sendValues();
        
        
      },


      /**
       * Add "salto de pregunta" item
       */
      addToItem(v){
        if(this.values.questions[v].to_list.length < 3){
          this.values.questions[v].to_list.push({
            action_response: "",
            to: ""
          });
        }
      },

      /**
       * Remove "salto de pregunta" item
       */
      removeToItem(index,toIndex){
        this.values.questions[index].to_list.splice(toIndex,1);
        this.sendValues();
      },


      /**
       * Add option item for multi question type
       */
      addMultiOption(v)
      {
        this.values.questions[v].option_list.push({
          option: "",
        });
      },

      processMultiNotApply(data){
        // let arr = []
        // arr.findIndex
        const found = this.values.questions[data.index].option_list.findIndex((x) => x.option == 'no aplica')
        console.log(found)
        if(data.value){
          if( found == -1){
            this.values.questions[data.index].option_list.push({
              option: "no aplica",
            });
          }
        }else{
          if( found >= 0){
            this.values.questions[data.index].option_list.splice(found, 1)
          }
        }
      },
      processMultiOther(data){
        // let arr = []
        // arr.findIndex
        const found = this.values.questions[data.index].option_list.findIndex((x) => x.option == 'otro')
        console.log(found)
        if(data.value){
          if( found == -1){
            this.values.questions[data.index].option_list.push({
              option: "otro",
            });
          }
        }else{
          if( found >= 0){
            this.values.questions[data.index].option_list.splice(found, 1)
          }
        }
      },

      /**
       * Remove option item for multi question type
       */
      removeMultiOptionItem(index, optionIndex)
      {
        if(this.values.questions[index].option_list.length == 1)
          return;
        this.values.questions[index].option_list.splice(optionIndex,1);
        this.sendValues();
      },



      /**
       * Create a list of questions
       * use with "salto de pregunta"
       */
      generateQuestionsIndexList()
      {
        this.questionsIndex = [];
        for (let i = 0; i < this.values.questions.length; i++) {
          this.questionsIndex.push({text:`Pregunta ${i+1}`, value:i});
        }
      },


      /**
       * Show/hide fab button
       */
      onScroll (e) 
      {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset ||   e.target.scrollTop || 0
        this.fab = top > 100
      },

      /**
       * Scroll to bottom
       */
      tobottom () {
        var container = this.$refs.formContainer;
        console.log(container.scrollHeight);
        this.$vuetify.goTo(container.scrollHeight)
      },

      sendValues(questions = null){
      
        
        this.$emit('updateValues', { questions: this.values.questions});
        
      },

      
    }
}
</script>

<style lang="scss">
  .tab{
    &-header{
      font-size: 12px !important;
      color: var(--v-normalText-lighten4) !important;
     
    }

    &-active{
      color: var(--v-normalText-base) !important;
    }

    &-error{
      color: var(--v-warning-base) !important;
    }

    
  }
  .less-margin{
    margin-bottom: -20px;
  }


  .fab-questionary{
    right: 10% !important;
    bottom: 10% !important;
  }

  .just-items-end{
    justify-items: flex-end;
  }

  .questionnaires-business-list {
    display: flex;
    align-items: baseline;
}
</style>